var map = {
	"./introduction-01.jpg": 4056,
	"./introduction-02.jpg": 8807,
	"./introduction-03.jpg": 4970,
	"./introduction-04.jpg": 5657,
	"./introduction-05.jpg": 7612,
	"./introduction-06.jpg": 411,
	"./introduction-07.jpg": 2574,
	"./introduction-08.jpg": 6845,
	"./introduction-09.jpg": 5712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7110;